export default function splitButtonTextIntoLetters(button) {
	if (!button) return;

	const text = button.textContent.trim();
	if (!text) return;

	// Clear the button content
	button.innerHTML = "";

	// Create a wrapper for the rolling text
	const rollingWrapper = document.createElement("div");
	rollingWrapper.className = "button-rolling-text";

	// Create the text container (block)
	const textContainer = document.createElement("div");
	textContainer.className = "button-text-block";

	// Split text into letters
	const letters = text.split("");
	const letterDelay = 0.015; // 15ms delay between each letter

	letters.forEach((letter, index) => {
		const letterSpan = document.createElement("span");
		letterSpan.className = "button-letter";
		// Use non-breaking space for actual spaces
		letterSpan.textContent = letter.trim() === "" ? "\xa0" : letter;
		letterSpan.style.transitionDelay = `${index * letterDelay}s`;
		textContainer.appendChild(letterSpan);
	});

	// Append the original text
	rollingWrapper.appendChild(textContainer);
	// Clone and append the duplicate for the rolling effect
	rollingWrapper.appendChild(textContainer.cloneNode(true));

	button.appendChild(rollingWrapper);
}
